SC.studio_detail_page = (function () { // eslint-disable-line
  var api = {};

  var init = function () {
    setEvents();
  };

  // Studio hero swiper
  api.swiper = new Swiper('.swiper-container', {
    pagination: '.swiper-pagination',
    paginationClickable: true,
    autoplay: 5000,
    centeredSlides: true,
    loop: true,
    autoplayDisableOnInteraction: false,
    speed: 400,
    slidesPerView: 3,
    loopAdditionalSlides: 1
  });

  // Instructor swiper
  api.instructorSwiper = new Swiper('.instructor-swiper', {
    slidesPerView: 4,
    spaceBetween: 30,
    freeMode: true,
    nextButton: '.instructor-swiper-next',
    prevButton: '.instructor-swiper-prev'
  });

  var setEvents = function () {
    // TAKEN FROM SOULCYCLE.JS
    $('body.logged-in .studio-header-container .fav-it').on('click keydown', function (e) {
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
        return;
      }

      var $favIcon = $(this);
      var studioId = $favIcon.data('studio-id');
      var studioTitle = $favIcon.data('studio-title');
      var wasFaved = $favIcon.hasClass('active');
      var enabled = wasFaved ? 0 : 1;
      var favAltText = 'Favorite ' + studioTitle;

      if (wasFaved === true) {
        $favIcon.removeClass('active');
      } else {
        $favIcon.addClass('active');
        favAltText = 'Remove ' + studioTitle + ' as favorite';
      }

      $favIcon.attr({
        'alt': favAltText,
        'aria-selected': !wasFaved
      });

      SC.utils.toggleFavoriteStudio(studioId, enabled);

      var studioData = $favIcon.data();
      var eventData = {
        'Location': studioData.location,
        'Studio Name': studioData.studioTitle,
        'Studio Location': studioData.studioRegion
      };
      var eventName = 'Click to Unfavorite a Studio';

      if (enabled) {
        /**
         * Old GA sendEvent - studio faved
         * Deprecated: Will be removed soon.
         *
         * action = faved
         * label = studio id
         */
        SC.analytics.ga.sendEvent('studio_details', 'faved', studioId.toString());

        // Set the eventName for mP event to Favorite.
        eventName = 'Click to Favorite a Studio';
      }

      /**
       * mParticle sendEvent - Click to Favorite/Unfavorite a Studio
       * Sends an mParticle event and a custom GA label.
       */
      SC.analytics.mp.sendEvent(eventName, 'navigation', eventData, studioData.location);
    });

    $('.studio-instructors .instructor-swiper-next').click(function () {
      /**
       * Old GA sendEvent - instructor swiper click next
       * Deprecated: Will be removed soon.
       */
      SC.analytics.ga.sendEvent('studio_details', 'click-next', 'instructor_swiper');
    });
    $('.instructor-swiper').on('swipeleft', function () {
      /**
       * Old GA sendEvent - instructor swiper swipe next
       * Deprecated: Will be removed soon.
       */
      SC.analytics.ga.sendEvent('studio_details', 'swipe-next', 'instructor_swiper');
    });

    $('.studio-email').on('click', function () {
      /**
       * Old GA sendEvent - Studio Email click.
       * Deprecated: Will be removed soon.
       */
      var studioId = $(this).data('studio-id');
      SC.analytics.ga.sendEvent('studio_detail', 'email_click', studioId);
    });

    $('.studio-telephone').on('click', function () {
      var studioId = $(this).data('studio-id');
      /**
       * Old GA sendEvent - Click on Studio Phone number.
       * Deprecated: Will be removed soon.
       */
      SC.analytics.ga.sendEvent('studio_detail', 'phone_click', studioId);

      /**
       * mparticle logEvent - Call Studio click.
       */
      SC.analytics.mp.sendEvent(
        'Call Studio',
        'navigation',
        {'Location': 'Studio Info Page'},
        'Studio Info Page'
      );
    });
  };

  init();

  return api;
})();
